module.exports = __webpack_public_path__ + "static/media/steefBartman.5373d88f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/steefBartman.jpg
// module id = 1590
// module chunks = 1